// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import FileUploadPresentationPropsDefault from "@insite/mobius/FileUpload/presentationProps";
import { xBaseTheme } from "@werner/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...FileUploadPresentationPropsDefault,
        sizeVariant: "small",
        mergeCss: true,
        labelProps: {
            size: 15,
            css: css`
                letter-spacing: 0;
                line-height: 21px;
            `,
        },
        buttonProps: {
            variant: "secondary",
            sizeVariant: "small",
            css: css`
                display: flex;
                line-height: unset;
                margin: 0;
                width: fit-content;
            `,
        },
    },
} as xBaseTheme["fileUpload"];
